import Divider, { type DividerProps } from "./Divider";
export { Divider as default, Divider, DividerProps };